const f = {
  color: {
    background: {
      default: "#ffffffff",
      disabled: "#f9fafaff"
    },
    text: "#405261ff",
    addOn: {
      text: "#314351ff"
    },
    placeholder: {
      default: "#7e8e9eff",
      error: "#fa7a64ff",
      success: "#47c47dff",
      warning: "#fac096ff"
    },
    control: {
      default: {
        color: "#7e8e9eff",
        bg: "#f9fafaff",
        border: "#abb9c7ff"
      },
      error: {
        color: "#e54a32ff",
        bg: "#fff0e8ff",
        border: "#fa7a64ff"
      },
      success: {
        color: "#2d8556ff",
        bg: "#f2fff0ff",
        border: "#47c47dff"
      },
      warning: {
        color: "#ac771bff",
        bg: "#fff6e5ff",
        border: "#fac096ff"
      }
    }
  },
  radius: {
    default: "8px"
  }
};
export {
  f as input
};
